// The selector's vocabulary, kept OUT of `selector.tsx`.
//
// `selector.tsx` reaches every tab through `main/selector-main.tsx`, and the tabs
// need these names back -- so an enum living there is a cycle, and a tab reading
// one at module scope (a tabs config, say) gets `undefined` because the shell is
// still evaluating. This file imports nothing, so it cannot be caught in one.
// It is also what an outside caller that only wants a tab name should import.

// Which host the selector is standing in -- the ONE switch between its two use
// cases. The geometry, the root's variant class and whether there is title
// chrome all follow from it (`mode-config.ts`), and every level reads it off the
// context rather than being handed the pieces (`context.tsx`).
export enum EntitySelectorMode {
    POPOVER = 'popover',    // the editor's @-mention popover: a fixed box, no chrome
    MODAL   = 'modal',      // "Add related item": fills its modal, heading and close
}

export enum EntitySelectorEntityType {
    USER        = 'recent',
    TASK        = 'browse',
    DOCUMENT    = 'document',
    PROJECT     = 'project',
    MEETING     = 'meeting',
}

// The sub-tabs within one entity type.
export enum EntitySelectorListType {
    RECENT      = 'recent',
    BROWSE      = 'browse',
    UPCOMING    = 'upcoming'
}

// A sidebar row. The label doubles as the content column's title.
export type EntitySelectorMenuItem = {
    id      : EntitySelectorEntityType
    icon    : string
    label   : string
}
